// extracted by mini-css-extract-plugin
export var bodySections = "_df-8";
export var gray = "_df-7";
export var green = "_df-4";
export var iconContainer = "_df-9";
export var iconWidgetContainer = "_df-1";
export var phoneIcon = "_df-2";
export var red = "_df-5";
export var statusDot = "_df-3";
export var widgetContainer = "_df-0";
export var yellow = "_df-6";